"use strict";

angular.module("internal.exams").controller("InternalExamTypeTrigger", [
    "$scope",
    "$state",
    "$stateParams",
    "TGTriggers",
    "$window",
    "Statuses",
    function (
        $scope,
        $state,
        $stateParams,
        TGTriggers,
        $window,
        Statuses
    ) {
        $scope.trigger = $stateParams.trigger;
        $scope.triggerID = $stateParams.id;
        $scope.triggerObjectID = $stateParams.triggerObjectID;
        $scope.examTypeID = $stateParams.examTypeID;
        $scope.saving = false;
        $scope.loading = false;
        $scope.saveMessage = null;
        $scope.statusOptions = null;

        if ($stateParams.id != null) {
            $scope.loading = true;
            TGTriggers.getByID($stateParams.id, $stateParams.triggerObjectID, $stateParams.configID).then(function (trigger) {
                $scope.trigger = trigger;
                $scope.loading = false;
                $scope.trigger.trigger_actions.forEach(function (action) {
                    if (action.name == "Process" && action.trigger_action_value != null && action.trigger_action_value.value_id != null) {
                        Statuses.getProcessStatuses(action.trigger_action_value.value_id).then(function (statuses) {
                            $scope.statusOptions = statuses;
                        });
                    }
                });
            });
        } else {
            $state.go("internal.exams.denied");
        }

        $scope.save = function () {
            $scope.saving = true;
            $scope.trigger.trigger_action_values = [];

            $scope.trigger.trigger_actions.forEach(function (action) {
                if (action.multiple) {
                    action.trigger_action_values.forEach(function (tav) {
                        tav.trigger_configuration_id = $stateParams.configID;
                        tav.trigger_action_id = action.id;
                        tav.trigger_object_id = $scope.triggerObjectID;
                        $scope.trigger.trigger_action_values.push(tav);
                    });
                } else {
                    if (action.text) {
                        if (action.trigger_action_value != null && action.trigger_action_value.value_text != null && action.trigger_action_value.value_text != "") {
                            action.trigger_action_value.trigger_configuration_id = $stateParams.configID;
                            action.trigger_action_value.trigger_action_id = action.id;
                            action.trigger_action_value.trigger_object_id = $scope.triggerObjectID;
                            $scope.trigger.trigger_action_values.push(action.trigger_action_value);
                        }
                    } else {
                        if (action.trigger_action_value != null && action.trigger_action_value.value_id != null && action.trigger_action_value.value_id != "") {
                            if (action.trigger_action_value.value_text != "Reference Date") {
                                action.trigger_action_value.date_value = null;
                            }
                            action.trigger_action_value.trigger_configuration_id = $stateParams.configID;
                            action.trigger_action_value.trigger_action_id = action.id;
                            action.trigger_action_value.trigger_object_id = $scope.triggerObjectID;
                            $scope.trigger.trigger_action_values.push(action.trigger_action_value);
                        }
                    }
                }
            });

            TGTriggers.save($scope.trigger, $scope.triggerObjectID, $stateParams.configID).then(
                function (trigger) {
                    $scope.saving = false;
                    if (trigger != null) {
                        $scope.saveMessage = "Record updated successfully";
                        $window.scrollTo(0, 0);
                    } else {
                        $scope.saveMessage = "Error: Save failed";
                        $window.scrollTo(0, 0);
                    }
                }
            );
        };

        $scope.setText = function (options, value, triggerActionName) {
            if (options != null && value != null) {
                options.forEach(function (opt) {
                    if (opt.id == value.value_id) {
                        value.value_text = opt.name;
                    }
                });
            }
            if (triggerActionName == 'Process') {
                Statuses.getProcessStatuses(value.value_id).then(function (statuses) {
                    $scope.statusOptions = statuses;
                });
            }
        };
    }
]);
